import React, {useRef, useCallback, useEffect, useState} from 'react';
import block from 'bem-cn-lite';
import _ from 'lodash';
import {TextInput} from '@yandex-data-ui/common';
import {ClassNameProps} from '@yandex-data-ui/cloud-components';

import ButtonWithIcon from 'components/Buttons/ButtonWithIcon/ButtonWithIcon';
import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';
import {useIsIPhone} from 'hooks/device';

import closeIcon from '@yandex-data-ui/common/assets/icons/remove.svg';
import searchIcon from 'icons/search.svg';

import './Search.scss';

const b = block('Search');

export type SearchSize = 's' | 'm';

interface SearchProps extends WithTranslationProps, ClassNameProps {
    value?: string;
    initialValue: string;
    onSubmit: (value: string) => void;
    debounce?: number;
    placeholder?: string;
    size?: SearchSize;
    autoFocus?: boolean;
}

const Search: React.FC<SearchProps> = (props) => {
    const {
        i18nK,
        className,
        initialValue,
        onSubmit,
        debounce = 300,
        placeholder = i18nK('search_placeholder'),
        size = 'm',
        autoFocus = false,
        value: externalValue,
    } = props;
    const [value, setValue] = useState<string>(initialValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onChangeDebounce = useCallback(_.debounce(onSubmit, debounce), []);
    const inputRef = useRef<HTMLInputElement>(null);
    const isIPhone = useIsIPhone();

    useEffect(() => {
        if (externalValue !== undefined) {
            setValue(externalValue);
        }
    }, [externalValue]);

    useEffect(() => {
        if (autoFocus && !isIPhone) {
            setTimeout(() => inputRef?.current?.focus({preventScroll: true}), 0);
        }
    }, [autoFocus, inputRef, isIPhone]);

    return (
        <div className={b({size}, className)}>
            <div className={b('search-suggest-container')} data-qa="search-suggest-container">
                <TextInput
                    value={value}
                    onUpdate={(query) => {
                        setValue(query);
                        onChangeDebounce(query);
                    }}
                    placeholder={placeholder}
                    className={b('search-suggest')}
                    size={size === 'm' ? 'xl' : 'l'}
                    controlRef={inputRef}
                />
            </div>
            {value ? (
                <ButtonWithIcon
                    className={b('close-button')}
                    icon={closeIcon}
                    iconSize={12}
                    size="xs"
                    onClick={() => {
                        onChangeDebounce.cancel();
                        setValue('');
                        onSubmit('');
                    }}
                />
            ) : (
                <ButtonWithIcon
                    className={b('search-button')}
                    icon={searchIcon}
                    iconSize={16}
                    size="xs"
                    disabled={true}
                />
            )}
        </div>
    );
};

export default withTranslation('marketplace')(Search);
